module.exports = __webpack_public_path__ + "media/creativeMedia/panel06Landscape-d9faaee9.png";